import React, { useEffect, useState } from "react";
import { Button, Result, Space, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { dataServiceUrl, intlDataServiceUrl } from "../../utils/constant";
import { useWorkspace } from "../../context/WorkspaceRegionProvider";
import { WORKSPACE_INTL } from "../../utils/workspace";
import styles from "./index.modules.less";

const ERROR_TYPE = {
  URL_MISSING: "url_missing",
  REDIRECT_FAILED: "redirect_failed",
};

const ERROR_CONFIG = {
  [ERROR_TYPE.URL_MISSING]: {
    title: "数据服务暂不可用",
    subTitle: "数据服务地址未配置，请联系管理员处理。",
    showRetry: false,
  },
  [ERROR_TYPE.REDIRECT_FAILED]: {
    title: "数据服务跳转失败",
    subTitle: "跳转过程中发生异常，请重试或联系管理员。",
    showRetry: true,
  },
};

const DataServiceRedirect = () => {
  const navigate = useNavigate();
  const { workspace } = useWorkspace();
  const [errorType, setErrorType] = useState("");
  const targetUrl =
    workspace === WORKSPACE_INTL ? intlDataServiceUrl : dataServiceUrl;

  const doRedirect = () => {
    if (!targetUrl) {
      setErrorType(ERROR_TYPE.URL_MISSING);
      return;
    }

    try {
      window.location.href = targetUrl;
    } catch (e) {
      setErrorType(ERROR_TYPE.REDIRECT_FAILED);
    }
  };

  useEffect(() => {
    doRedirect();
  }, []);

  if (errorType) {
    const config = ERROR_CONFIG[errorType];
    return (
      <Result
        status="warning"
        title={config.title}
        subTitle={config.subTitle}
        extra={
          <Space direction="vertical" align="center">
            <Space>
              {config.showRetry && (
                <Button type="primary" onClick={() => { setErrorType(""); doRedirect(); }}>
                  重试跳转
                </Button>
              )}
              <Button onClick={() => navigate("/view/home")}>
                返回首页
              </Button>
            </Space>
            <span className={styles.contactTip}>
              如持续失败，请联系主账号管理员处理
            </span>
          </Space>
        }
      />
    );
  }

  return (
    <div className={styles.loading}>
      <Spin />
      <span>正在跳转数据服务，请稍候...</span>
    </div>
  );
};

export default DataServiceRedirect;
